import { render, staticRenderFns } from "./Rekanan.vue?vue&type=template&id=257030ee"
import script from "./Rekanan.vue?vue&type=script&lang=js"
export * from "./Rekanan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports